import React, { useEffect, useState } from 'react';
import './InputComponent.css';
import DropdownComponent from '../DropdownComponent/DropdownComponent';
import InputComponent from './InputComponent';
import { countryCodeOptions } from '../../utils/countryCodeOptions';

const DEFAULT_COUNTRY = '+1';

const MobileInputComponent = ({
    disabled = false,
    name,
    placeholder = 'WhatsApp Number',
    value = '',
    onChange,
    error,
    onBlur,
    style = {},
}) => {
    const [countryCode, setCountryCode] = useState(DEFAULT_COUNTRY);
    const [number, setNumber] = useState('');
    const [maxLength, setMaxLength] = useState(10);

    /* 🌍 Detect user country calling code on initial mount */
    useEffect(() => {
        // Only auto-detect if no value is pre-populated
        if (!value) {
            fetch('https://ipapi.co/json/')
                .then((res) => res.json())
                .then((data) => {
                    if (data && data.country_calling_code) {
                        const apiCallingCode = data.country_calling_code; // e.g., "+1", "+91"

                        // Check if detected calling code exists in your dropdown options
                        const found = countryCodeOptions.find(c => c.id === apiCallingCode);
                        if (found) {
                            setCountryCode(found.id);
                            setMaxLength(found.length || 10);
                        }
                    }
                })
                .catch((err) => {
                    console.error('Failed to fetch user country code:', err);
                });
        }
    }, []);

    /* 🔁 Sync from parent value (edit case) */
    useEffect(() => {
        if (!value) {
            setNumber('');
            return;
        }

        const found = countryCodeOptions.find(c => value.startsWith(c.id));
        if (found) {
            setCountryCode(found.id);
            setMaxLength(found.length);
            setNumber(value.replace(found.id, '').slice(0, found.length));
        }
    }, [value]);

    /* 🔁 emit unified value */
    const emitChange = (finalValue) => {
        onChange({
            target: {
                name,
                value: finalValue,
            },
        });
    };

    /* 🌍 country code change */
    const handleCountryChange = (e) => {
        const newCode = e.target.value;
        const found = countryCodeOptions.find(c => c.id === newCode);

        const newLength = found?.length || 10;
        const trimmedNumber = number.slice(0, newLength);

        setCountryCode(newCode);
        setMaxLength(newLength);
        setNumber(trimmedNumber);

        emitChange(newCode + trimmedNumber);
    };

    /* 📱 mobile number change */
    const handleNumberChange = (e) => {
        const num = e.target.value.replace(/\D/g, '').slice(0, maxLength);
        setNumber(num);
        emitChange(countryCode + num);
    };

    return (
        <div className="whatsapp-field" style={style}>
            <div className="country-code">
                <DropdownComponent
                    disabled={disabled}
                    value={countryCode}
                    onChange={handleCountryChange}
                    options={countryCodeOptions}
                />
            </div>

            <div className="whatsapp-number">
                <InputComponent
                    disabled={disabled}
                    name={name}
                    placeholder={placeholder}
                    value={number}
                    onChange={handleNumberChange}
                    error={error}
                    onBlur={onBlur}
                    maxLength={maxLength}
                />
            </div>
        </div>
    );
};

export default MobileInputComponent;
